<template>
  <div>
    <hshead title="微信绑定" bgcolor="#fff"></hshead>
    <div>
      <van-cell-group>
        <van-field
          v-model="mobile"
          label="手机号"
          placeholder="请输入手机号"
          maxlength="20"
        />        
      </van-cell-group>
      <van-cell-group style="display:flex">
        <van-field
          v-model="verifyCode"
          center
          clearable
          label="图形验证码"
          placeholder="输入验证码"
          class="mobileCode"
          style="flex:1"
        >
          <!-- <van-button slot="button" size="small" type="primary" @click="getCode()">{{sendCodeText}}</van-button> -->
        </van-field>
        <van-image
          width="1.6rem"
          height="44px"
          :src="verifyCodeImageBase64"
          @click="handleVerifyCodeClick"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="mobileCode" center clearable label="短信验证码" placeholder="输入验证码">
          <van-button slot="button" size="small" type="primary" @click="getCode()">{{sendCodeText}}</van-button>
        </van-field>
      </van-cell-group>
      <van-cell>
        <van-button type="info" size="large" class="my-btn" @click="handleBindWechat">确定绑定</van-button>
      </van-cell>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Toast,
  List,
  CellGroup,
  Cell,
  Field,
  Button,
  Dialog,
  Image
} from "vant";
import { GetWechatAuthUrl } from "@/utils/common";
import {
  getStoreExtractCashPager,
  bindWechat as bindWechatConfirm,
  getUser
} from "@/api/m/user";
import { sendCode, verifyCodeImageBase64 } from "@/api/common";
import Cookies from "js-cookie";

export default {
  name: "modifyPwd",
  data() {
    return {
      tempData: {},
      codeTime: 0, // 发送验证码的时间
      timeOut: "", // 倒计时事件
      verifyCodeImageBase64: "",
      //
      openid: null,
      mobile: null,
      sendCodeText: "发送",
      verifyCode: "",
      mobileCode: ""
    };
  },
  methods: {
    //跳转到微信网页授权
    redirectToWeixin() {
      const url = `${window.location.origin + window.location.pathname}`;
      window.location.href = GetWechatAuthUrl(url);
    },
    handleVerifyCodeClick() {
      this.getVerifyCodeImageBase64();
    },
    getCode() {
      let self = this;
      if (self.mobile.length != 11) {
        self.tips("请确保手机号码是正确的！");
        return;
      }
      if (self.codeTime !== 0) {
        self.tips("请勿重复点击发送验证码！");
        return;
      }
      if (this.verifyCode == "") {
        this.tips("请输入图形验证码", 1000 * 3);
        return;
      }
      //验证图形验证码，正常才发送手机验证码
      sendCode(self.mobile, this.verifyCode, "getCash")
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('sendCode -> data', data)
            //this.sendCodeText = '60s'
            let self = this;
            if (self.codeTime == 0) {
              self.tips("验证码已发送，请注意查收");
              self.codeTime = 60;
              // 自调用
              self.timeOut = setInterval(() => {
                self.codeTime--;
                self.sendCodeText = self.codeTime + "s";
                if (self.codeTime === 0) {
                  clearInterval(self.timeOut);
                  self.sendCodeText = "发送";
                }
              }, 1000);
            }
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    // 图形验证码
    getVerifyCodeImageBase64: function() {
      verifyCodeImageBase64()
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('verifyCodeImageBase64 -> data', data)
            this.verifyCodeImageBase64 = data.base64String;
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    // 提交
    handleBindWechat: function() {
      let self = this;
      if (!self.mobile) {
        self.tips("请填写手机号码");
        return false;
      }
      if (self.mobile.length != 11) {
        self.tips("请检查手机号码格式");
        return false;
      }
      if (!self.mobileCode) {
        self.tips("请填写验证码");
        return false;
      }

      Dialog.confirm({
        title: "确认操作",
        message: `绑定后收益将提现到绑定的微信账号上，且不可变更绑定，是否继续？`
      }).then(() => {
        this.load(true, "提交中...");
        bindWechatConfirm({
          Mobile: self.mobile,
          Code: self.mobileCode,
          OpenId: self.openid
        })
          .then(response => {
            this.load(false);
            const { code, msg, data } = response;
            if (code >= 0) {
              self.tips(`绑定成功`);
              self.verifyCode = "";
              self.mobile = "";
              self.mobileCode = "";
              setTimeout(() => {
                window.location.href = "/";
              }, 500);
            }
          })
          .catch(response => {
            this.load(false);
            this.tips(`${response.msg}`);
          });
      });
    },
    getUser() {
      this.load(true, "加载中...");
      getUser()
        .then(response => {
          this.load(false);
          this.mobile = response.mobile;
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response}`);
          Toast.fail({ duration: 1000 * 5, message: `${response}` });
        });
    }
  },
  created() {
    let self = this;
    self.openid = Cookies.get("openid");
    if (!self.openid) {
      self.redirectToWeixin();
    }
    self.getUser();
    self.getVerifyCodeImageBase64();
  },
  components: {
    hshead,
    "van-list": List,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-button": Button,
    "van-image": Image,
    [Dialog.Component.name]: Dialog.Component
  }
};
</script>

<style lang="less" scoped>
// @import "~@/assets/less/common.less";
// @import "~@/assets/less/mixin.less";
.my-btn {
  border-radius: 1rem !important;
  background-color: #00b8f5 !important;
  font-size: 14px !important;
  border-color: transparent;
  height: 35px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/bindWechat.vue